import { TSuggest } from 'feature/registration/types'

type ApplyAddressActions = {
  setInputAddressSuggest: (value: TSuggest) => void
  setIsValidAddress: (value: boolean) => void
  setInputAddress: (value: string) => void
  setClickMarkCoords: (coords: [number, number]) => void
}

type ClearAddressActions = {
  clearMap: () => void
  clearAddress: () => void
}

export const createEmptyAddress = (): TSuggest => ({
  address: '',
  fiasId: '',
  fiasLevel: '',
  geoLat: '',
  geoLon: '',
  regionFiasId: '',
  kladrId: '',
  regionKladrId: '',
  areaKladrId: '',
  cityKladrId: '',
  cityDistrictKladrId: '',
  settlementKladrId: '',
  streetKladrId: '',
  houseKladrId: '',
  house: '',
})

export const applyAddressToMap = (
  address: TSuggest | null,
  actions: ApplyAddressActions,
) => {
  if (!address || !address.address?.length) return

  actions.setInputAddressSuggest(address)
  if (address.house) {
    actions.setIsValidAddress(true)
  }
  actions.setInputAddress(address.address)
  actions.setClickMarkCoords([Number(address.geoLat), Number(address.geoLon)])
}

export const clearAddressState = (actions: ClearAddressActions) => {
  actions.clearMap()
  actions.clearAddress()
}
